// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/snippet_featured_small.css
// module id = 86
// module chunks = 0